import { render, staticRenderFns } from "./FormMoneyInput.vue?vue&type=template&id=3d28c8d0&scoped=true&"
import script from "./FormMoneyInput.vue?vue&type=script&lang=ts&"
export * from "./FormMoneyInput.vue?vue&type=script&lang=ts&"
import style0 from "./FormMoneyInput.vue?vue&type=style&index=0&id=3d28c8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d28c8d0",
  null
  
)

export default component.exports